// STILE PERSONALIZZATO
import './App.css';
import './style/Style.scss'
import 'bootstrap/dist/css/bootstrap.min.css';

// LINKING
import {Route, Switch, useLocation} from "react-router-dom"

// COMPONENTS
import NavigationBar from './components/NavigationBar';
import Footer from './components/Footer';

//PAGES
import Home from './pages/Home';
import PageNotFound from './pages/PageNotFound';
import Registrati from "./pages/Autenticazione/Registrati";
import RegistrazioneCheck from './pages/Autenticazione/RegistrazioneCheck';
import AggiungiPagamento from './pages/Account/AggiungiPagamento';
import Accedi from './pages/Autenticazione/Accedi';
import RecuperaPassword from './pages/Autenticazione/RecuperaPassword';
import Profilo from './pages/Account/Profilo';
import LoginEffettuato from './pages/Autenticazione/LoginEffettuato';
import ModificaInfoPersonali from './pages/Account/ModificaInfoPersonali';
import ListaVeicoli from './pages/Catalogo/ListaVeicoli';
import ListaAuto from './pages/Catalogo/ListaAuto';
import ListaMoto from './pages/Catalogo/ListaMoto';
import ListaBici from './pages/Catalogo/ListaBici';
import ListaMonopattini from './pages/Catalogo/ListaMonopattini';
import ModificaNonAutorizzata from './pages/AccessoNonAutorizzato';
import AggiungiPatente from './pages/Account/AggiungiPatente';
import ModificaPassword from './pages/Account/ModificaPassword';
import ListaImpiegati from './pages/Amministrazione/Impiegati/ListaImpiegati';
import AggiungiImpiegato from './pages/Amministrazione/Impiegati/AggiungiImpiegato';
import RegistrazioneCheckImpiegato from './pages/Amministrazione/Impiegati/RegistrazioneImpiegatoCheck';
import ListaParcheggi from './pages/Amministrazione/Parcheggi/ListaParcheggi';
import AggiungiParcheggio from './pages/Amministrazione/Parcheggi/AggiungiParcheggio';
import Noleggia from './pages/Catalogo/Noleggia';
import ChiSiamo from './pages/Footer/ChiSiamo';
import Contatti from './pages/Footer/Contatti';
import TerminiDuso from './pages/Footer/TerminiDuso';
import PolitichePrivacy from './pages/Footer/PolitichePrivacy';
import RegistrazioneCheckParcheggio from './pages/Amministrazione/Parcheggi/RegistrazioneParcheggioCheck';
import Prenotazioni from './pages/Prenotazioni/Prenotazioni';
import Ritardo from './pages/Prenotazioni/Ritardo';
import Incarichi from './pages/Incarichi/Incarichi';
import Specifiche from './pages/Catalogo/Specifiche';




function App() {

  const location = useLocation()


    return (
      <Switch location={location} key={location.pathname}>
            <Route path="*">
            <NavigationBar/>
              <Switch>
                
              
                <Route path="/" exact component={Home}>
                  <Home/>
                </Route>

                <Route path="/account/info/:id/ModificaInfoPersonali" exact component={ModificaInfoPersonali}>
                  <ModificaInfoPersonali/>  
                </Route>

                <Route path="/account/info/:id" exact component={Profilo}>
                  <Profilo/>
                </Route>
                
                <Route path="/account/login" exact component={Accedi}>
                  <Accedi/>
                </Route>

                <Route path="/account/loginEffettuato" exact component={LoginEffettuato}> 
                  <LoginEffettuato/> 
                </Route>

                <Route path="/account/recuperaPassword" exact component={RecuperaPassword}> 
                  <RecuperaPassword/> 
                </Route>

                <Route path="/account/registrati" exact component={Registrati}>
                  <Registrati/>
                </Route>

                <Route path="/account/registrati/registrazioneCheck" exact component={RegistrazioneCheck}>
                  <RegistrazioneCheck/>  
                </Route>
                
                <Route path="/account/info/:id" exact component={Profilo}>
                  <Profilo/>
                </Route>

                <Route path="/account/info/:id/aggiungiPagamento" exact component={AggiungiPagamento}>
                  <AggiungiPagamento/>  
                </Route>

                <Route path="/account/info/:id/aggiungiPatente" exact component={AggiungiPatente}>
                  <AggiungiPatente/>  
                </Route>

                <Route path="/account/info/:id/modificaPassword" exact component={ModificaPassword}>
                  <ModificaPassword/>  
                </Route>

                <Route path="/listaVeicoli" exact component={ListaVeicoli}>
                  <ListaVeicoli/>
                </Route>

                <Route path="/listaVeicoli/listaAuto" exact component={ListaAuto}>
                  <ListaAuto/>
                </Route>

                <Route path="/listaVeicoli/listaMoto" exact component={ListaMoto}>
                  <ListaMoto/>
                </Route>

                <Route path="/listaVeicoli/listaBici" exact component={ListaBici}>
                  <ListaBici/>
                </Route>

                <Route path="/listaVeicoli/listaMonopattini" exact component={ListaMonopattini}>
                  <ListaMonopattini/>
                </Route>

                <Route path="/veicoli/specifiche/:modello" exact component={Specifiche}>
                  <Specifiche/>
                </Route>


                <Route path="/ModificaNonAutorizzata" exact component={ModificaNonAutorizzata}>
                  <ModificaNonAutorizzata/>
                </Route>

                
                <Route path="/amministratore/listaImpiegati" exact component={ListaImpiegati}>
                  <ListaImpiegati/>
                </Route>

                <Route path="/amministratore/aggiungiImpiegato" exact component={AggiungiImpiegato}>
                  <AggiungiImpiegato/>
                </Route>

                <Route path="/amministratore/aggiungiImpiegato/registrazioneCheckImpiegato" exact component={RegistrazioneCheckImpiegato}>
                  <RegistrazioneCheckImpiegato/>
                </Route>

                <Route path="/amministratore/aggiungiParcheggio/registrazioneCheckParcheggio" exact component={RegistrazioneCheckParcheggio}>
                  <RegistrazioneCheckParcheggio/>
                </Route>

                <Route path="/amministratore/listaParcheggi" exact component={ListaParcheggi}>
                  <ListaParcheggi/>
                </Route>

                <Route path="/amministratore/aggiungiParcheggio" exact component={AggiungiParcheggio}>
                  <AggiungiParcheggio/>
                </Route>

                <Route path="/veicoli/:modelloVeicolo/noleggia" exact component={Noleggia}>
                  <Noleggia/>
                </Route>

                <Route path="/Chi Siamo" exact component={ChiSiamo}>
                  <ChiSiamo/>
                </Route>

                <Route path="/Contatti" exact component={Contatti}>
                  <Contatti/>
                </Route>

                <Route path="/Termini di Uso" exact component={TerminiDuso}>
                  <TerminiDuso/>
                </Route>

                <Route path="/Politiche Privacy" exact component={PolitichePrivacy}>
                  <PolitichePrivacy/>
                </Route>

                <Route path="/Prenotazioni/ListaPrenotazioni/:id_cliente" exact component={Prenotazioni}>
                  <Prenotazioni/>
                </Route>

                <Route path="/Prenotazioni/Ritardo/:idPrenotazione" exact component={Ritardo}>
                  <Ritardo/>
                </Route>

                <Route path="/incarichi/ListaIncarichi/:idImpiegato" exact component={Incarichi}>
                  <Incarichi/>
                </Route>

                


                
                <Route path="*" exact component={PageNotFound}/>

              </Switch>

              <Footer/>
            </Route>
          </Switch>
      
  );
}

export default App;
